import React from 'react';
import './OrderNotFound.css';

const OrderNotFound = ({ error }) => {
    return (
        <div className="not-found-body">
            <div className="not-found-icon-wrapper">
                <i className="fas fa-file-invoice"></i>
            </div>
            {error && <h2 className="not-found-title">{error.message || 'Order Not Found'}</h2>}
            <p className="not-found-text">
                {error?.description || 'The order you are looking for could not be found.'}
            </p>
        </div>
    );
};

export default OrderNotFound;
